module.exports = __webpack_public_path__ + "static/img/word.ee5e22d1.png";